const TIARA_REFERRER_KEY = "t_referrer";
const DEFAULT_TIARA_REFERRER = {
  t_src: "",
  t_ch: "",
  t_obj: ""
};
const getTiaraReferrerFromStorage = () => {
  const referrer = window.sessionStorage.getItem(TIARA_REFERRER_KEY);
  return referrer ? JSON.parse(referrer) : DEFAULT_TIARA_REFERRER;
};
const appendTiaraReferrer = (url) => {
  const originalUrl = new URL(url);
  const tiaraReferrerFromStorage = getTiaraReferrerFromStorage();
  const tCh = originalUrl.searchParams.get("t_ch") || tiaraReferrerFromStorage.t_ch;
  const tSrc = originalUrl.searchParams.get("t_src") || tiaraReferrerFromStorage.t_src;
  const tObj = originalUrl.searchParams.get("t_obj") || tiaraReferrerFromStorage.t_obj;
  originalUrl.searchParams.set("t_ch", tCh);
  originalUrl.searchParams.set("t_src", tSrc);
  originalUrl.searchParams.set("t_obj", tObj);
  return originalUrl.toString();
};
export {
  appendTiaraReferrer
};
